// src/services/authService.js
import { api } from './api.service';

const headers =  {
    'Content-Type': 'multipart/form-data',
  };

const authService ={
    async login(email, password) {
        const response = await api.post('/login', { 'email': email , 'password': password });
        return response.data;
    },

    login2(email, password) {
        const response = api.post('/login', { 'email': email , 'password': password });
        return response.data;
    },

    register(credentials) {
        try {
            const response = api.post('/register', { nome, email, senha });
            return response.data;
          } catch (error) {
            console.error('Erro ao registrar usuário:', error);
            throw error;
          }
    },

    logout(){
        localStorage.removeItem('token');
    }
}

export default authService;

